import { useTranslation } from 'react-i18next';
import { Box, Container, Typography } from '@mui/material';
import Page from '../../components/Page';
import AnnouncementForm from '../../sections/@dashboard/announcements/AnnouncementForm';

export default function SaveAnnouncement() {
  const { t } = useTranslation();

  return (
    <Page title={t('announcement_form')}>
      <Container maxWidth="xl">
        <Typography variant="h4" gutterBottom mb={4}>
          {t('create_announcement') || 'Crear Anuncio'}
        </Typography>
        <Box sx={{ background: '#fff', borderRadius: 3, p: { xs: 2, md: 4 }, boxShadow: '0 1px 8px 0 rgba(3,44,101,0.07)' }}>
          <AnnouncementForm />
        </Box>
      </Container>
    </Page>
  );
}
